<template>
  <poppins-popup :value="value" popupHeader="Contact" @close="closePopup">
    <p v-if="jobRecruitInfo.recruitedBySeeker" class="text-grey-body text-small">
      You’ve shared a job with {{ profileAccountData.displayName }}
    </p>
    <poppins-button
      v-for="button in popupButtons"
      :key="button.value"
      class="w-full mt-16"
      size="medium"
      :value="button.value"
      :variant="button.variant"
      :href="button.href"
      @click.prevent="handleButtonClick(button)"
    />
  </poppins-popup>
</template>

<script lang="ts">
import Popup from '@/components/popup/Popup.vue';
import Button from '@/components/button/Button.vue';
import { JOB_RECRUIT } from '@/graphql/provider/profile/queries';
import { sendSegmentEvent } from '@/lib/segment';
import { setRecentlyViewedProviderId } from '@/lib/recentlyViewedProfile';

export default {
  name: 'ProviderProfileContactPopup',
  components: {
    PoppinsPopup: Popup,
    PoppinsButton: Button,
  },
  props: {
    profileAccountData: {
      default: () => ({}),
      type: Object,
    },
    accountTypeInfo: {
      default: () => ({}),
      type: Object,
    },
    value: {
      type: Boolean,
      required: true,
    },
    careType: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      jobRecruitInfo: {} as any,
    };
  },
  computed: {
    popupButtons() {
      const buttons = [] as any;

      const upgradeToPremiumPath = '/upgrade/pricing';
      const isPremiumParent =
        this.accountTypeInfo.isParent &&
        (this.accountTypeInfo.accountType === 'premium' ||
          this.accountTypeInfo.accountType === 'corporate' ||
          this.accountTypeInfo.accountType === 'family_concierge');
      const isBasicParent = this.accountTypeInfo.isParent && !isPremiumParent;
      if (
        this.jobRecruitInfo.eligibleForRecruit &&
        !this.jobRecruitInfo.recruitedBySeeker &&
        (this.careType === 'babysitter' || this.careType === 'nanny')
      )
        buttons.push({
          value: 'Invite to Apply',
          href: `/messages/new?uuid=${this.profileAccountData?.id}&displayName=${this.profileAccountData?.displayName}&returnPath=${window.location.pathname}&source=profile&checkAvailability=true`,
          variant: 'outlined',
        });
      buttons.push({
        value: isPremiumParent && this.profileAccountData?.viewerHasMessaged ? 'Open Conversation' : 'Message',
        // eslint-disable-next-line no-nested-ternary
        href: isBasicParent
          ? upgradeToPremiumPath
          : this.profileAccountData?.viewerHasMessaged
            ? `/messages?uuid=${this.profileAccountData?.id}`
            : `/messages/new?uuid=${this.profileAccountData?.id}&displayName=${this.profileAccountData?.displayName}&returnPath=${window.location.pathname}&source=profile`,
        variant: 'outlined',
      });
      if (
        this.profileAccountData?.viewerHasMessaged &&
        (this.profileAccountData?.profiles?.babysitter?.profileVisible ||
          this.profileAccountData?.profiles?.nanny?.profileVisible)
      )
        buttons.push({
          value: 'Interview',
          href: isBasicParent ? upgradeToPremiumPath : `/interview-request/${this.profileAccountData?.id}/new`,
          variant: 'outlined',
        });
      buttons[0].variant = 'primary';
      return buttons;
    },
  },
  watch: {
    profileAccountData(newValue) {
      if (newValue?.id) {
        this.fetchJobRecruit();
      }
    },
  },
  methods: {
    fetchJobRecruit() {
      if (this.accountTypeInfo.isParent) {
        this.$apollo
          .query({
            query: JOB_RECRUIT,
            variables: {
              providerId: this.profileAccountData?.id,
            },
          })
          .then(({ data }) => {
            this.jobRecruitInfo = data.jobRecruit;
          })
          .catch((error) => {
            // eslint-disable-next-line no-console
            console.error('Error fetching job recruit info:', error);
          });
      }
    },
    handleButtonClick(button) {
      if (this.accountTypeInfo?.isBasic) setRecentlyViewedProviderId(this.profileAccountData?.id);

      if (button.value === 'Invite to Apply') {
        sendSegmentEvent('Check Availability Clicked', {
          sitter_uuid: this.profileAccountData?.id,
          care_type: this.careType,
        });
      } else if (button.value === 'Message' || button.value === 'Open Conversation') {
        sendSegmentEvent('Message Sitter Clicked', {
          sitter_uuid: this.profileAccountData?.id,
          care_type: this.careType,
        });
      } else if (button.value === 'Interview') {
        this.$store.dispatch('interviewRequest/setSitterUuid', this.profileAccountData?.id);
        sendSegmentEvent('Interview Sitter Clicked', {
          sitter_uuid: this.profileAccountData?.id,
          care_type: this.careType,
        });
      }
      // Allow default navigation
      window.location.href = button.href;
    },
    closePopup() {
      this.$emit('close');
    },
  },
};
</script>
